<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ju3RUL/tc-custom/9781459229921.jpg?1741132405493" alt="This image is the cover for the book Gladiator's Honor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gladiator's Honor
      </h1>
      <p class="bookDescription body article font2">
        <b>Sold into slavery!</b><br/><br/>A hardened survivor of more than a dozen gladiatorial combats, Valens’s raw masculinity fuels many women’s sexual fantasies. He is outside polite society, and Roman noblewoman Julia Antonia knows she should have nothing to do with a man who is little more than a slave.<br/><br/>But with a wisp of scandal clinging to her <i>stola</i>, Julia is drawn inexorably toward the forbidden danger he represents. For Valens, Julia is a tantalizing reminder of the life he’d been torn from. To claim her, he must fight one final timeand win!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Styles
      </h2>
      
      <p class="authorDescription body article">Michelle Styles writes warm, witty and intimate historical romance in a range of periods including Viking &#160;and early Victorian. Born and raised near San Francisco, California, &#160;she &#160;currently lives near Hadrian&#39;s Wall in the UK with her husband, menagerie of pets and occasionally one of her three university-aged children. An avid reader, she became hooked on historical romance after discovering &#160;Georgette Heyer, Anya Seton and Victoria Holt. &#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f595fd2